import { Component, input, output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { provideTranslocoScope } from '@jsverse/transloco';
import { sharedImports } from '../../sharedImports';
import { HasFormControlDirective } from '@directives/has-form-control.directive';
import { AutoErrorDirective } from '@directives/number-auto-error.directive';
import { NumberErrorType } from '@compeople-shared/design-system';
import { hasCustomError, updateErrors } from '@utils/custom-error.utils';

@Component({
  selector: 'art-stock-location-price-form',
  imports: [ReactiveFormsModule, sharedImports, HasFormControlDirective, AutoErrorDirective],
  templateUrl: './stock-location-price-form.component.html',
  styleUrls: ['./stock-location-price-form.component.scss'],
  providers: [provideTranslocoScope('artwork'), provideTranslocoScope('error')],
  standalone: true,
})
export class StockLocationPriceFormComponent {
  stockLocationPriceForm = input.required<FormGroup>();
  mq4 = input('6-(6)/2-2-2-2-4/2-4-(6)/12');
  readonly = input(false);
  protected readonly NumberErrorType = NumberErrorType;

  autoErrors: Record<string, boolean> = {};
  customErrors = output<boolean>();

  get locations(): FormArray {
    return this.stockLocationPriceForm().get('locations') as FormArray;
  }

  updateControlErrors(event: Record<string, boolean>) {
    this.autoErrors = updateErrors(this.autoErrors, event);
    this.customErrors.emit(hasCustomError(this.autoErrors));
  }
}
